<template>
  <drawer :show="show" :toggle="toggleDrawer">
    <form ref="filterDrawerForm">
      <fieldset
        class="ah-filter-drawer-group"
        v-for="(filterGroup, i) in filterGroups"
        :key="`filter-group-${i}`"
      >
        <legend class="ah-filter-drawer-group-label">
          {{ filterGroup.label }}
        </legend>
        <div class="ah-filter-drawer-group-filters">
          <div
            class="ah-filter-drawer-group-filter"
            v-for="(filter, j) in filterGroup.filters"
            :key="`filter-group-${i}-filter-${j}`"
          >
            <input
              type="checkbox"
              :id="`filter-group-${i}-filter-${j}`"
              :name="filter.name"
              :checked="filter.active"
              @change="event => handleChange(event, filter)"
            />
            <label
              :for="`filter-group-${i}-filter-${j}`"
            >
              {{ filter.name }}
            </label>
          </div>
        </div>
      </fieldset>
      <div>
        <button
          class="ah-filter-drawer-submit-button"
          @click="toggleDrawer"
        >
          {{ showLabel }}
          <span v-if="!!numberOfResults">
            ({{ numberOfResults }})
          </span>
        </button>
      </div>
    </form>
  </drawer>
</template>

<script>
  import { store, mutations } from '../data/store'
  import Drawer from './Drawer.vue'

  export default {
    name: 'filter-drawer',
    props: {
      filters: Array,
      submitButtonLabel: {
        type: String,
        default: 'Show',
      },
      //numberOfResults: Number,
      onSubmit: Function,
    },
    data: function() {
      return {
        closeLabel: window.vueData.components['filter-drawer'].closeButtonAriaLabel || 'Close',
        showLabel: window.vueData.components['filter-drawer'].submitButtonLabel || 'Show results'
      }
    },
    computed: {
      numberOfResults: function() {
        return store.resultsCount
      },
      show: function() {
        return store.showFilterDrawer
      },
        filterGroups: function () {
            let species = store.species;
            species.sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
            const otherAnimals = species.findIndex(i => i.internalName === 'Other animals');
            species.push(species[otherAnimals]);
            species.splice(otherAnimals, 1);

            let therapies = store.therapies;
            therapies.sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
            const otherTherapies = therapies.findIndex(i => i.internalName === 'Other');
            therapies.push(therapies[otherTherapies]);
            therapies.splice(otherTherapies, 1);
        return [
            {
            label: window.vueData.components['filters'].categoryLabel || 'Categories',
            filters: store.categories,
          },
          {
            label: window.vueData.components['filters'].speciesLabel || 'Species',
            filters: species,
          },
          {
            label: window.vueData.components['filters'].therapiesLabel || 'Therapy area',
            filters: therapies,
          },
        ]
      },
    },
    methods: {
      handleChange: function(e, filter) {
        mutations.toggleFilter(filter)
      },
      handleSubmit: function(e) {
        // TODO:
      },
      toggleDrawer: function(e) {
        e.preventDefault()
        mutations.toggleFilterDrawer()
      }
    },
    components: {
      Drawer,
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_variablesAH.scss";

  .ah-filter-drawer {
    position: absolute;
    top: 0;
    right: 0;
    width: 330px;
    height: 100%;
    padding: 52px 24px;
    overflow-y: auto;
    box-sizing: border-box;
    box-shadow: 0 0 60px 0 rgba(0,35,74,0.25);
  }
  .ah-filter-drawer-group {
    border: none;
    margin: 0 0 24px 0;
    padding: 0;
  }
  .ah-filter-drawer-group-label {
    font-family: $font-main;
    font-size: 17px;
    font-weight: 600;
    color: black;
    margin-bottom: 12px;
  }
  .ah-filter-drawer-group-filter {
    height: 23px;
    margin-bottom: 4px;
    font-family: $font-main;
    font-size: 17px;
    color: $ah-blue;
    &, & input, & label {
      cursor: pointer;
    }
  }
  .ah-filter-drawer-submit-button {
    width: 100%;
    height: 44px;
    background-color: $blue-a;
    color: $ah-orange;
    font-family: $font-main;
    font-size: 16px;
    font-weight: 600;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
</style>